// import { PageModule } from 'data/generated/graphql';

// interface PageModuleBasicProps {
//   pageModule: PageModule;
//   onChange: ((pageModule: PageModule) => void) | null;
// }

export const PageModuleBasic = (/* { pageModule, onChange } PageModuleBasicProps */) => <></>;
